import React from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import { ROUTES } from '../../routes'
import styles from './index.module.scss'

export default function TermsAndConditionsDisplay () {
  return (
    <div className='list-group-item'>
      <div className={styles.container}>
        <div>
          <div className={styles.title}>Terms and Conditions</div>
          <div className={cn(styles.description, styles.mdText)}>
            Create and manage Terms and Conditions templates and settings
          </div>
        </div>

        <Link
          to={ROUTES.termsAndConditionsAgreements}
          className={cn(styles.btnLink, 'dis-btn dis-btn-sm dis-btn-primary-lt')}>
          <span className={styles.mdText}>T&C SETTINGS</span>
        </Link>
      </div>
    </div>
  )
}
